(() => {
  if (window.ITPEntry24) { window.ITPEntry24.scan(document); return; }
  const instances = new WeakMap();
  const init = root => {
    if (instances.has(root)) return;
    const welcome = root.querySelector('[data-entry21-welcome]');
    const worlds = root.querySelector('[data-entry21-worlds]');
    const start = root.querySelector('[data-entry21-start]');
    const back = root.querySelector('[data-entry21-back]');
    const title = root.querySelector('[data-entry21-title]');
    if (!welcome || !worlds || !start || !back || !title) return;
    const events = new AbortController();
    const listen = (node, type, handler, options = {}) => node?.addEventListener(type, handler, { ...options, signal: events.signal });
    const media = matchMedia('(prefers-reduced-motion: reduce)');
    const fine = matchMedia('(hover: hover) and (pointer: fine)');
    const html = document.documentElement;
    const image = root.querySelector('[data-entry24-camera] img');
    const animations = new Set();
    let camera, disposed = false, suspended = false, frame = 0, pointer = { x: .5, y: .5 };
    const allowed = () => html.dataset.motion !== 'off' && html.dataset.readingCalm !== 'on' && (!media.matches || html.dataset.motionChoice === 'on');
    const blocked = () => suspended || document.hidden || !!document.querySelector('dialog[open]');
    const cancel = () => { animations.forEach(animation => animation.cancel()); animations.clear(); };
    const animate = (node, frames, duration, delay = 0) => {
      if (!node?.animate || !allowed() || blocked()) return;
      const animation = node.animate(frames, { duration, delay, easing: 'cubic-bezier(.2,.7,.2,1)', fill: 'backwards' });
      animations.add(animation);
      animation.finished.then(() => animations.delete(animation), () => animations.delete(animation));
    };
    const cameraPolicy = () => {
      if (!allowed() || ['large', 'larger'].includes(html.dataset.readingSize)) { camera?.cancel(); camera = null; return; }
      if (blocked() || root.dataset.entry21Stage !== 'welcome') { camera?.pause(); return; }
      if (!camera && image?.animate) {
        camera = image.animate([{ transform: 'scale(1.025) translateX(0)' }, { transform: 'scale(1.09) translateX(-.55%)' }], { duration: 18000, iterations: Infinity, direction: 'alternate', easing: 'ease-in-out' });
        camera.finished.catch(() => {});
      } else camera?.play();
    };
    const measure = () => {
      frame = 0;
      if (disposed || blocked()) return;
      const bounds = welcome.getBoundingClientRect();
      const progress = allowed() ? Math.max(0, Math.min(1, -bounds.top / Math.max(1, bounds.height * .5))) : 0;
      root.style.setProperty('--entry24-camera-x', `${(allowed() ? (pointer.x - .5) * -16 : 0).toFixed(2)}px`);
      root.style.setProperty('--entry24-camera-y', `${(allowed() ? (pointer.y - .5) * -10 + progress * 18 : 0).toFixed(2)}px`);
      root.style.setProperty('--entry24-scroll-scale', (1 + progress * .08).toFixed(4));
    };
    const schedule = () => { if (!disposed && !frame) frame = requestAnimationFrame(measure); };
    const preferences = () => {
      root.dataset.entry21Motion = allowed() ? 'on' : 'off';
      if (!allowed()) cancel();
      cameraPolicy();
      schedule();
    };
    const show = (stage, focus = false) => {
      const choosing = stage === 'worlds';
      const changed = root.dataset.entry21Stage !== stage;
      cancel();
      welcome.hidden = choosing;
      welcome.inert = choosing;
      worlds.hidden = !choosing;
      worlds.inert = !choosing;
      root.dataset.entry21Stage = stage;
      if (focus) (choosing ? title : start).focus({ preventScroll: true });
      cameraPolicy();
      if (!changed) return;
      if (choosing) {
        root.querySelectorAll('[data-entry24-shutter]').forEach((shutter, index) => animate(shutter, [{ transform: 'scaleY(1)' }, { transform: 'scaleY(0)' }], 480, index * 12));
        animate(root.querySelector('.entry21__choice-heading'), [{ transform: 'translateY(16px)' }, { transform: 'translateY(0)' }], 420);
        root.querySelectorAll('.entry21__card').forEach((card, index) => {
          animate(card, [{ clipPath: 'inset(0 0 14% 0)', transform: 'translateY(14px)' }, { clipPath: 'inset(0 0 0% 0)', transform: 'translateY(0)' }], 500, index * 30);
          animate(card.querySelector('img'), [{ transform: 'scale(1.14)' }, { transform: 'scale(1)' }], 540, index * 26);
        });
      } else if (focus) animate(welcome.querySelector('.entry21__intro'), [{ transform: 'translateY(12px)' }, { transform: 'translateY(0)' }], 420);
      schedule();
    };
    const changeHash = hash => { const url = new URL(location.href); url.hash = hash; history.replaceState(history.state, '', url); };
    const normalClick = event => event.button === 0 && !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey;
    listen(start, 'click', event => { if (!normalClick(event)) return; event.preventDefault(); changeHash('Worlds21'); show('worlds', true); });
    listen(back, 'click', event => { if (!normalClick(event)) return; event.preventDefault(); changeHash(''); show('welcome', true); });
    listen(window, 'hashchange', () => show(location.hash === '#Worlds21' ? 'worlds' : 'welcome'));
    listen(welcome, 'pointermove', event => {
      if (!fine.matches || !allowed() || event.pointerType === 'touch' || root.dataset.entry21Stage !== 'welcome') return;
      const bounds = welcome.getBoundingClientRect();
      pointer = { x: Math.max(0, Math.min(1, (event.clientX - bounds.left) / Math.max(1, bounds.width))), y: Math.max(0, Math.min(1, (event.clientY - bounds.top) / Math.max(1, bounds.height))) };
      schedule();
    }, { passive: true });
    listen(welcome, 'pointerleave', () => { pointer = { x: .5, y: .5 }; schedule(); });
    listen(window, 'scroll', schedule, { passive: true });
    listen(window, 'resize', schedule, { passive: true });
    listen(document, 'visibilitychange', () => { cameraPolicy(); schedule(); });
    listen(window, 'pagehide', () => { suspended = true; camera?.pause(); cancel(); cancelAnimationFrame(frame); frame = 0; });
    listen(window, 'pageshow', () => { suspended = false; cameraPolicy(); schedule(); });
    listen(media, 'change', preferences);
    const observer = new MutationObserver(preferences);
    observer.observe(html, { attributes: true, attributeFilter: ['data-motion', 'data-motion-choice', 'data-reading-calm', 'data-reading-size'] });
    const dialogs = new MutationObserver(cameraPolicy);
    dialogs.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['open'] });
    listen(document, 'shopify:section:unload', event => {
      if (!event.target.contains(root)) return;
      disposed = true;
      cancel(); camera?.cancel(); cancelAnimationFrame(frame);
      observer.disconnect(); dialogs.disconnect(); events.abort();
      welcome.hidden = false; welcome.inert = false; worlds.hidden = false; worlds.inert = false;
      delete root.dataset.entry21Enhanced;
      delete root.dataset.entry21Stage;
      instances.delete(root);
    });
    instances.set(root, true);
    root.dataset.entry21Motion = allowed() ? 'on' : 'off';
    show(location.hash === '#Worlds21' ? 'worlds' : 'welcome');
    root.dataset.entry21Enhanced = 'true';
    schedule();
  };
  const scan = (context = document) => context.querySelectorAll('[data-entry21]').forEach(init);
  window.ITPEntry24 = { scan };
  scan();
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
